(function () {
  var PHOTO_SEL =
    '.tpo_option-set-wrapper label[style*="url("], .tpo_option-set-wrapper label img, .tpo_buttons-wrapper > label img, .tpo_buttons-wrapper > label[style*="url("], [class*="tpo_image"] label, [class*="tpo_swatch"] label img, .swatch[style*="url("]';

  function absUrl(url) {
    if (!url) return '';
    url = String(url).replace(/&amp;/g, '&').trim();
    if (url.indexOf('//') === 0) url = window.location.protocol + url;
    else if (url.indexOf('/') === 0) url = window.location.origin + url;
    return url.replace(/([?&]width=)\d+/i, '$12000');
  }

  function productRoot(node) {
    if (!node) return document.querySelector('product-info');
    if (node.closest) return node.closest('product-info') || document.querySelector('product-info');
    return document.querySelector('product-info');
  }

  function modalFor(root) {
    var id = root && root.dataset ? root.dataset.section : '';
    if (id) {
      var box = document.querySelector('#ProductModal-' + id);
      if (box) return box;
    }
    return document.querySelector('product-modal.product-media-modal');
  }

  function photosFor(root) {
    if (!root) return null;
    var el =
      root.querySelector('.uc-swatch-photos') ||
      document.getElementById('uc-swatch-photos') ||
      document.getElementById('uc-hat-photos');
    if (!el) {
      var pid = root.dataset && root.dataset.productId;
      if (pid) el = document.querySelector('.uc-swatch-photos[data-product-id="' + pid + '"]');
    }
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function hasPhotoSwatches(root) {
    if (photosFor(root)) return true;
    var scope = root || document;
    return !!scope.querySelector(PHOTO_SEL);
  }

  function isHatPage(root) {
    return !!(root && root.classList.contains('uc-product--photo-top'));
  }

  function targets(root) {
    var imgs = [];
    var box = modalFor(root);
    [root, box].forEach(function (scope) {
      if (!scope) return;
      scope.querySelectorAll('.product__media img, .product-media-modal__content img, product-modal img').forEach(function (img) {
        if (imgs.indexOf(img) === -1) imgs.push(img);
      });
    });
    return imgs;
  }

  function state(root) {
    if (!root) return null;
    if (!root._ucPhoto) root._ucPhoto = { lastUrl: '', watching: false };
    return root._ucPhoto;
  }

  function paint(root, url) {
    url = absUrl(url);
    if (!root || !url) return;
    var store = state(root);
    store.lastUrl = url;
    var hat = isHatPage(root);
    targets(root).forEach(function (img) {
      img.classList.add('uc-hat-live');
      img.classList.toggle('uc-hat-live--contain', hat);
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      var inModal = !!(img.closest && img.closest('product-modal, .product-media-modal__content'));
      if (hat || inModal) {
        img.style.objectFit = 'contain';
        img.style.objectPosition = 'center center';
        img.style.background = '#fff';
      } else {
        img.style.objectFit = 'cover';
        img.style.objectPosition = 'center center';
        img.style.background = '';
      }
    });
  }

  function fromVariant(root, id) {
    var map = photosFor(root);
    if (!map || id == null || id === '') return false;
    var url = map[String(id)];
    if (!url) return false;
    paint(root, url);
    return true;
  }

  function currentVariantId(root) {
    if (!root) return '';
    var input = root.querySelector('input[name="id"]');
    return input ? input.value : '';
  }

  function photoFromNode(node) {
    if (!node || !node.closest) return '';
    var label =
      node.closest('.swatch-input__label') ||
      node.closest('.tpo_buttons-wrapper > label') ||
      node.closest('[class*="tpo_swatch"] label') ||
      node.closest('[class*="tpo_image"] label') ||
      node.closest('.tpo_option-set-wrapper label') ||
      node.closest('label');
    if (!label) {
      if (node.classList && node.classList.contains('swatch')) label = node;
      else return '';
    }
    var img = label.querySelector ? label.querySelector('img') : null;
    if (img && img.getAttribute('src')) return img.getAttribute('src');
    var styled = [label];
    if (label.querySelectorAll) {
      label.querySelectorAll('.swatch, [style*="url("], [style*="background"]').forEach(function (el) {
        styled.push(el);
      });
    }
    for (var i = 0; i < styled.length; i++) {
      var style = styled[i].getAttribute && (styled[i].getAttribute('style') || '');
      var match = style.match(/url\(\s*(['"]?)([^'")]+)\1\s*\)/i);
      if (match) return match[2];
    }
    return '';
  }

  function isPhotoPick(node) {
    if (!node || !node.closest) return false;
    if (node.closest('.swatch-input__label .swatch[style*="url("], .swatch[style*="url("]')) return true;
    if (node.closest('.swatch-input__label')) {
      var lab = node.closest('.swatch-input__label');
      return !!(lab && lab.querySelector('.swatch[style*="url("]'));
    }
    var label = node.closest('label');
    if (!label) return false;
    if (label.closest('.tpo_option-set-wrapper, [class*="tpo_swatch"], [class*="tpo_image"], .tpo_buttons-wrapper')) {
      return !!(label.querySelector('img') || /url\(/i.test(label.getAttribute('style') || ''));
    }
    return false;
  }

  function isZoomClick(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('.product__media-toggle, .product__modal-opener, product-modal, .product-media-modal__content');
  }

  function pickFromNode(root, node) {
    if (fromVariant(root, currentVariantId(root))) return;
    var url = photoFromNode(node);
    if (url) paint(root, url);
  }

  function sync(root) {
    var store = state(root);
    if (!fromVariant(root, currentVariantId(root)) && store.lastUrl) paint(root, store.lastUrl);
  }

  function watch(root) {
    var store = state(root);
    if (!root || store.watching || typeof MutationObserver === 'undefined') return;
    store.watching = true;
    var observer = new MutationObserver(function () {
      if (!store.lastUrl) return;
      var img = root.querySelector('.product__media img');
      var current = (img && img.getAttribute('src')) || '';
      var needle = store.lastUrl.replace(/^https?:/, '');
      if (!current || current.indexOf(needle) === -1) paint(root, store.lastUrl);
      var modalImg = modalFor(root) && modalFor(root).querySelector('img');
      if (modalImg) {
        var msrc = modalImg.getAttribute('src') || '';
        if (!msrc || msrc.indexOf(needle) === -1) paint(root, store.lastUrl);
      }
    });
    observer.observe(root, { childList: true, subtree: true });
    var box = modalFor(root);
    if (box) observer.observe(box, { childList: true, subtree: true });
  }

  function onPick(event) {
    var root = productRoot(event.target);
    if (!root) return;
    if (isZoomClick(event.target)) {
      var store = state(root);
      var url = store.lastUrl;
      if (!url) {
        var live = root.querySelector('.product__media img');
        url = live && live.getAttribute('src');
      }
      if (url) {
        paint(root, url);
        requestAnimationFrame(function () {
          paint(root, url);
        });
      }
      return;
    }
    if (!hasPhotoSwatches(root)) return;
    if (!isPhotoPick(event.target)) return;
    pickFromNode(root, event.target);
  }

  document.addEventListener('pointerdown', onPick, true);
  document.addEventListener('click', onPick, true);
  document.addEventListener('change', function (event) {
    var root = productRoot(event.target);
    if (!root || !hasPhotoSwatches(root) || !event.target) return;
    if (event.target.name === 'id' || event.target.classList.contains('swatch-input__input')) {
      sync(root);
      return;
    }
    if (isPhotoPick(event.target) || (event.target.closest && isPhotoPick(event.target))) {
      pickFromNode(root, event.target);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var id = event && event.data && event.data.variant && event.data.variant.id;
      var root =
        (event && event.target && productRoot(event.target)) ||
        document.querySelector('product-info');
      if (!root || !hasPhotoSwatches(root) || !id) return;
      fromVariant(root, id);
      requestAnimationFrame(function () {
        fromVariant(root, id);
        setTimeout(function () {
          fromVariant(root, id);
        }, 80);
      });
    });
  }

  function start() {
    document.querySelectorAll('product-info').forEach(function (root) {
      watch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
